module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/~/react/react.js
 ** module id = 337
 ** module chunks = 12
 **/